export const attendanceViewModes = ['daily', 'weekly'] as const;
export type AttendanceViewMode = typeof attendanceViewModes[number];
export const defaultAttendanceViewMode: AttendanceViewMode = 'daily';
export interface AttendanceSettingsData {
  viewMode: AttendanceViewMode;
}
